<script>
  import { onMount } from "svelte"
  import { push, querystring } from "svelte-spa-router"
  import Footer from "../../../../Shared/footer.svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import Table from "../../../../Shared/Table/table.svelte"
  import List from "./Components/cardList.svelte"
  import Filter from "./Components/filterComponent.svelte"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import notify from "../../../../Script/notify"
  import AuthInput from "../../../../Shared/authInput.svelte"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { deleteRequest, getRequest, postRequest } from "../../../../Script/apiMethods"

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching List of Signers"
  /**
   * @type {Boolean} for showing Loader while loading the list of file templates
   */
  let showLoading = false

  let limit
  let page
  let sort
  let sortBy
  let search = {
    searchParam: "name",
    searchvalue: "",
  }
  let startDate = null
  let endDate = null

  /**
   * @type {String} - which state document need to show
   */
  let status = null
  let signers = []
  console.log(signers, signers.length)

  let fileCount
  let code
  let revokeOTPModal = false
  let revokeId = ""

  let query

  let closeNotification = {
    close() {},
  }

  // List page api -fetch all list of templates.
  onMount(async () => {
    try {
      // Prevent execution if unauthorized (because pop() is asynchronous)
      if (!$ApplicationState.pdfEnabled || !$ApplicationState.msignToken) return

      query = queryStringToJSON($querystring)

      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      status = query.state ? query.state : "active"
      search.searchParam = query.sin ? query.sin : "name"
      if (query.sname) search.searchvalue = query.sname

      await fetchSigners()
    } catch (error) {
      const info = "PAGE: Signer List\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  const fetchSigners = async () => {
    try {
      showLoading = true

      const data = await getRequest(`/api/pdf-signing/v2/internal/signers?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      // console.log(data)

      fileCount = data.count
      signers = data.signers || []
      push(`/signing/signer?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}${status ? `&state=${status}` : ``}`)
    } catch (error) {
      throw error
    } finally {
      showLoading = false
    }
  }

  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      status = e.detail.filter.mode ? e.detail.filter.mode : status
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchSigners()
    } catch (error) {
      const info = "PAGE: Signer List\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name/ email/ id/ status, or navigating pages."
      notify.danger(error, info)
    }
  }

  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = 1
      sortBy = "date"
      search.searchvalue = ""
      startDate = null
      endDate = null
      status = "active"
      await fetchSigners()
    } catch (error) {
      const info = "PAGE: Signer List\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }

  /**
   * Confirm the authentication code entered by the user.
   * Extracts the code from the input fields, hides the confirmation modal, and triggers a specific function.
   * @param {Event} e - The event object, representing the form submission.
   */
  const handleRevokation = async (e) => {
    try {
      revokeOTPModal = false
      loadingText = "Revoking signer"
      showLoading = true
      let target = e.detail.target

      // Extract the authentication code from the input fields
      code = target[0].value + target[1].value + target[2].value + target[3].value + target[4].value + target[5].value

      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      // Validate Auth code
      const { signProxyPass } = await postRequest(
        `/api/swagger/v2/misc/proxy-sign`,
        {
          otp: code,
        },
        CONFIG
      )

      console.log({ signProxyPass })

      // Generate Signature
      const { signature } = await postRequest(
        `/api/swagger/v2/misc/proxy-sign`,
        {
          signProxyPass,
          msg: revokeId,
        },
        CONFIG
      )

      console.log({ signature })

      // Revoke Signer
      await deleteRequest(`/api/pdf-signing/v2/internal/signers/${revokeId}`, {
        data: { signature },
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      notify.success(`Signer revoked successfully`)
      await fetchSigners()
    } catch (error) {
      // console.error(error)
      closeNotification.close()
      code = ""
      const info = "PAGE: Signer List\nEVENT: Error occurred while revoking signer."
      closeNotification = notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

<svelte:head>
  <title>List of Signers</title>
</svelte:head>

{#if showLoading}
  <LoadingScreen msg={loadingText} />
{/if}

{#if revokeOTPModal}
  <div class="fixed inset-0 -top-3 z-50 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
    <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
      <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
        <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Revoke Confirmation</h1>
      </div>

      <div class="px-3 py-3">
        <AuthInput
          bind:code
          on:submit={handleRevokation}
          cancelBtn={true}
          on:click={() => (revokeOTPModal = false)}
          title="
          Please enter the <strong>Authentication Code for Docchain.io</strong> from the linked Authenticator App to confirm the revokation of the Signer.
          <br /><span class='text-red-500 font-bold'>This action is irreversible.</span>
          "
        />
      </div>
    </div>
  </div>
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="px-6 pb-12 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <!-- file Temp ListToggle Switch -->

      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        on:click={() => {
          push(`/signing/signer/add`)
        }}
        class="absolute right-0 top-0 z-10 flex h-9 w-max min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500"
      >
        <span>
          <i class="fa-solid fa-plus" />
        </span>
        <span class="hidden sm:block">&nbsp;Add Signer</span>
        <span class="block sm:hidden">&nbsp;Add</span>
      </div>

      <Table on:changeEntries={whileChangingEntries} entriesList={[10, 50, 100]} title={"List of Signers"} filterComponent={Filter} jsonData={signers} count={fileCount} filter={true} on:resetEntries={resetList}>
        {#if signers.length}
          <!-- <div class="flex w-full flex-wrap"> -->
          <div class="w-full space-y-3">
            {#each signers as signer}
              <!-- <div class="h-[290px] w-1/2 p-1 mobile:w-1/3 md:w-1/4"> -->
              <List
                {signer}
                on:revoke={() => {
                  revokeId = signer.id
                  revokeOTPModal = true
                }}
              />
              <!-- </div> -->
            {/each}
          </div>
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no Signers</div>
        {/if}
      </Table>
    </div>
  </div>
  <Footer />
</div>
